/**
 * Browser DataSource
 * @module
 */

var Query = require('./query');
var WindowEnv = require('../env/window');

/**
 *
 * @returns {string|undefined}
 */
exports.getLanguage = function(): string|undefined {
  return WindowEnv.getNavigatorLanguage();
};

/**
 * @return {Array} [['foo', 'val1'], ['foo2', 'val2'], ['foo3', 'val3']]
 */
exports.getQueryParams = Query.getQueryParams;

/**
 * Get the value of a specific query param by name.
 * @param {string} name
 * @returns {string|undefined}
 */
exports.getQueryParamValue = Query.getQueryParamValue;

// TODO -- figure out exactly what we need from this
exports.getUrl = function () {
  return WindowEnv.getHref();
};

